import { BRIDGE_ERROR, BRIDGE_METHODS } from '../../constants/bridge';
import { buildCancel, buildRequest, parseResponse } from '../post-message/protocol';
import { fail } from '../result';

const defaultId = () => crypto.randomUUID();

// Native iOS app (ios/): a WKWebView whose script message handler replies to
// each postMessage with a promise. It reuses the postMessage envelopes, so the
// native side answers with the same response shape the iframe host uses.
export function createWebKitAdapter({ handler, createId = defaultId }) {
    async function request(method, payload, { signal } = {}) {
        const id = createId();
        const handleAbort = () => {
            handler.postMessage(buildCancel(id)).catch(() => {});
        };
        signal?.addEventListener('abort', handleAbort, { once: true });
        try {
            const response = parseResponse(await handler.postMessage(buildRequest(id, method, payload)));
            return response?.id === id ? response.result : fail(BRIDGE_ERROR.INVALID_RESPONSE);
        } catch {
            return fail(BRIDGE_ERROR.FAILED);
        } finally {
            signal?.removeEventListener('abort', handleAbort);
        }
    }

    const methods = Object.fromEntries(
        Object.values(BRIDGE_METHODS).map((method) => [method, (payload, options) => request(method, payload, options)]),
    );

    return { host: 'webkit', methods };
}
